import '@app-bootstrappers/banner.bootstrapper'
import { HeaderTheme, setHeaderDisplay, setHeaderTheme } from '@app-components'

(() => {
    const heroContainer = document.getElementById('simple-page-hero')!

    if (heroContainer === null) {
        return
    }

    const observer = new IntersectionObserver(([element]) => {
        if (element.intersectionRatio >= 0.85) {
            setHeaderDisplay('none')
            setHeaderTheme(HeaderTheme.TRANSPARENT_WHITE)
        } else {
            setHeaderDisplay('brand-logo')
            setHeaderTheme(HeaderTheme.WHITE)
        }
    }, { threshold: [1, 0.85, 0.1, 0] })

    observer.observe(heroContainer)
})()

const responsiveIFrameGenerator = (iFrame: HTMLIFrameElement): void => {
    const container = document.createElement('div')
    container.classList.add('iframe-container')

    const parentNode = iFrame.parentNode

    if (! parentNode) return

    parentNode.insertBefore(container, iFrame)

    parentNode.removeChild(iFrame)

    container.appendChild(iFrame)

    iFrame.removeAttribute('width')
    iFrame.removeAttribute('height')
}

document.querySelectorAll('iframe').forEach((iFrame) => responsiveIFrameGenerator(iFrame))
